import { $win, getCurrentDevice } from './utils';
import fullsizeImagesUI from './fullsize';
import currentYear from './current-year';
import adaUI from './ada';
import cookiesUI from './cookie';
import headerUI from './header';
import menuUI from './menu';
import subscribeUI from './subscribe';
import personalizationUI from './modules/personalizationUI';
import BookingMask from './BookingMask';

;(function(window, document, $) {
	BookingMask();

	$('.js-move').each(function() {
		const $this = $(this);
		const $target = $($this.data('target'));

		$target.append($this);
	});

	$('.js-move-inside').each(function() {
		const $this = $(this);
		const $targetSelector = $this.data('target');
		const $target = $this.parents('.js-move-parent').find($targetSelector);

		$target.append($this);
	});

	$('a[href^="tel"]').each(function() {
		const linkHref = $(this).attr('href');

		$(this).attr('href', linkHref.replace(/ /igm, ''));
	});

	$('.js-trim-decimals').each(function() {
		const number = Math.trunc($(this).text());

		$(this).text(number);
	});

	if (getCurrentDevice !== 'desktop') {
		$('.box').on('click', function() {
			$(this).find('.box__inner')
					.addClass('active')
						.parents('.box')
							.siblings()
								.find('.box__inner')
									.removeClass('active');
		});
	}

	$('.js-select-tab select').on('change', function () {
		$(this.value).addClass('show active').siblings().removeClass('show active');
	});

	$('.js-add-commas').each(function() {
		const number = $(this).text();
		const length = number.length;

		if ( length > 3 ) {
			$(this).text(number.slice(0, length - 3) + ',' + number.slice(length - 3,length));
		}
	});

	$('.js-toggle').on('click', function() {
	    const $this = $(this);
	    const $target = $($this.data('target'));

	    $this.toggleClass('active');
	    $target.slideToggle();
	});

	$('.js-date').each(function() {
		const $this = $(this);
		const dateText = $this.data('date') ? $this.data('date') : $this.text();
		const date = moment(dateText);
		const format = $this.data('format');

		if ( date.isValid() ) {
			$this.html(date.format(format));
		} else {
			$this.remove();
		}
	});

	if ($('.js-custom-select').length) {
		import(/* webpackChunkName: "select" */ './select.js').then(module => {
			module.default();
		});
	}

	$('.js-scroll-to-top').on('click', function(event) {
		event.preventDefault();

		$('html, body').animate({
			scrollTop: 0
		});
	});

	$('.tabs').each(function() {
		const $firstTab = $(this).find('.tab-pane').first();
		const $firstTabLink = $(this).find('.nav-link').first();

		$firstTab.addClass('show active');
		$firstTabLink.addClass('active').attr('aria-selected', 'true');
	});

	fullsizeImagesUI();

	if ($('.js-slider').length) {
		import(/* webpackChunkName: "sliders" */ './sliders.js').then(module => {
			module.default();
		});
	}

	if ($('.js-filter').length || $('.js-filter-select').length || $('.js-filters').length) {
		import(/* webpackChunkName: "filtersUI" */ './filtersUI.js').then(module => {
			module.default()
		});
	}

	if ( $('.js-gallery').length ) {
		import(/* webpackChunkName: "gallery" */ './gallery.js').then(module => {
			module.default()
		});
	}

	adaUI();

	// Add js-year-container class where you want to print the current year
	currentYear();

	if ($('[data-shave]').length) {
		import(/* webpackChunkName: "shave-ui" */ './shave-ui.js').then(module => {
			module.default();
		});
	}

	if ($('[data-read-more]').length) {
		import(/* webpackChunkName: "read-more-ui" */ './read-more-ui.js').then(module => {
			module.default();
		});
	}

	if ($('.map').length) {
		import(/* webpackChunkName: "maps-ui" */ './maps-ui.js').then(module => {
			module.default();
		});
	}

	if ($('.js-form').length) {
		import(/* webpackChunkName: "forms-ui" */ './forms-ui.js').then(module => {
			module.default();
		});
	}

	cookiesUI();

	if ($('.js-datepicker-forms').length) {
		import(/* webpackChunkName: "range-picker-forms" */ './range-picker-forms.js').then(module => {
			module.default();
		});
	}

	headerUI();

	menuUI();

	subscribeUI();

	$win.on('load', function() {
		import(/* webpackChunkName: "booking" */ './booking.js').then(module => {
			module.default();
		});
	});

	personalizationUI();
})(window, document, window.jQuery);
